module.exports = __webpack_public_path__ + "static/img/banner14.329d80d6.png";